// Third Party
import React from 'react';

// Components
import EditBMOContact from './EditBMOContact';
import GenericContact from '@/types/generic-contact';
import Modal from '@/views/components/modals/AccessibleModal';

type Props = {
  show: boolean;
  contact: Partial<GenericContact>;
  onCancel: () => void;
  onSave: (contact: GenericContact) => GenericContact;
};

const EditBMOContactModal = (props: Props) => (
  <Modal show={props.show} className="modal-v2" onHide={props.onCancel} dialogClassName="modal-dialog-centered" backdrop="static">
    <Modal.Body className="d-flex flex-column">
      <EditBMOContact contact={props.contact} onSave={props.onSave} onCancel={props.onCancel} />
    </Modal.Body>
  </Modal>
);

export default EditBMOContactModal;
